import { Route, Routes } from 'react-router';
import { LeadPage } from './pages/LeadPage';
import { LeadsPage } from './pages/LeadsPage';
import { ComingSoonPage } from './pages/ComingSoonPage';
import { DashboardPage } from './pages/DashboardPage';
import { Layout } from './pages/Layout';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { StatementPage } from './pages/StatementPage';
import { StatementsPage } from './pages/StatementsPage';

export function App() {
  return (
    <Routes>
      {/* /login shows the email form; /login#<token> is the emailed link. */}
      <Route path="login" element={<LoginPage />} />
      <Route element={<Layout />}>
        <Route index element={<DashboardPage />} />
        <Route path="leads" element={<LeadsPage />} />
        <Route path="leads/:id" element={<LeadPage />} />
        <Route path="inscrire" element={<RegisterPage />} />
        <Route path="decomptes" element={<StatementsPage />} />
        <Route path="decomptes/:id" element={<StatementPage />} />
        <Route path="*" element={<ComingSoonPage />} />
      </Route>
    </Routes>
  );
}
